<template>
    <v-container grid-list-xl fluid>
        <v-row>
            <v-col cols="12" sm="6">
                <h1>Roterização e Etiquetas</h1>
            </v-col>
            <v-col cols="12" sm="6" v-if="item.store != null">
                <v-btn :color="items && items.length > 0 ? 'grey white--text' : 'success'" width="100%" small @click="openImport = true" v-if="openImport == false">
                    <v-icon> file_upload </v-icon>
                    Importar Rotas
                </v-btn>
            </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-flex xs12 v-if="item.store != null">
            <div class="subtitle-1"><strong>CD:</strong> {{ item.store.name }}</div>
            <div class="subtitle-1" v-if="item.code"><strong>Código:</strong> {{ item.code }}</div>
            <div class="subtitle-1" v-if="storeName"><strong>CD:</strong> {{ storeName }}</div>
        </v-flex>

        <v-flex xs12 v-else>
            <ChecklistHistory type="stick" label="Últimas etiquetagens" @reopen="reopen" />
            <StoreList labelNotFound="Não foi localizado nenhuma CD." labelSelect="Selecione abaixo o CD que você ira etiquetar:" endpoint="checklists/stick/stores"
                @selected="start" />
        </v-flex>

        <v-divider class="my-4" />

        <div v-if="item.store != null">
            <v-flex xs12 v-if="openImport == true">
                <Import :store="item.store.id" @close="closeImport" />
            </v-flex>

            <v-flex xs12 v-if="openImport == false && items && items.length > 0">
                <Sticker :store="item.store.id" :code="item.code" :items2="items" @refresh="getItems" />
            </v-flex>
            <v-flex xs12 v-else-if="openImport == false">
                <v-alert outlined color="error" prominent border="top" icon="error">
                    <strong>Nenhum pacote localizado para etiquetar.</strong>
                </v-alert>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
import Import from "./Import";
import Sticker from "./Sticker";
import StoreList from "@/components/shared/StoreList";
import ChecklistHistory from "@/components/shared/ChecklistHistory";

const itemClean = {
    extraCode: null,
    ordersNumber: null,
    store: null,
};

export default {
    components: { Import, Sticker, StoreList, ChecklistHistory },

    data() {
        return {
            openImport: true,
            items: null,
            store: undefined,
            storeName: null,
            item: JSON.parse(JSON.stringify(itemClean)),
        };
    },

    methods: {
        reopen(result) {
            if (result) {
                this.item = result;
                this.getItems();
            }
        },
        closeImport() {
            this.getItems();
            this.openImport = false;
        },
        start(store) {
            this.item.store = store;
            this.getItems();
        },
        startBip(ordersNumber) {
            this.item.ordersNumber = ordersNumber;
            this.$http
                .post(`checklists/stick/create`, this.item)
                .then((result) => {
                    if (result) {
                        this.item = result;
                        console.log(result);
                    } else {
                        this.$eventHub.$emit("msgError", this.$t("Erro ao criar um romaneio"));
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao criar um romaneio"));
                });
        },
        getItems() {
            if (this.item.store !== undefined && this.item.store.id !== undefined) {
                this.$http
                    .get(`routing/${this.item.store.id}?timezone=0`)
                    .then((result) => {
                        this.items = result;
                        if (this.items && this.items.length > 0) {
                            this.openImport = false;
                            this.startBip(this.items.length);
                        }
                    })
                    .catch(() => (this.items = []));
            }
        }
    }
};
</script>